const latestTransction = [
  {
    id: 11,
    orderId: "#NZ1572",
    date: "04 Apr, 2020",
    billingName: "Walter Brown",
    total: "$172",
    badge: "Paid",
  },
  {
    id: 10,
    orderId: "#NZ1571",
    date: "03 Apr, 2020",
    billingName: "Jimmy Barker",
    total: "$165",
    badge: "unpaid",
  },
  {
    id: 9,
    orderId: "#NZ1570",
    date: "03 Apr, 2020",
    billingName: "Donald Bailey",
    total: "$146",
    badge: "Paid",
  },
  {
    id: 8,
    orderId: "#NZ1569",
    date: "02 Apr, 2020",
    billingName: "Paul Jones",
    total: "$183",
    badge: "Paid",
  },
  {
    id: 7,
    orderId: "#NZ1568",
    date: "04 Apr, 2020",
    billingName: "Walter Brown",
    total: "$172",
    badge: "Chargeback",
  },
  {
    id: 6,
    orderId: "#NZ1567",
    date: "04 Apr, 2020",
    billingName: "Walter Brown",
    total: "$172",
    badge: "unpaid",
  },
  {
    id: 5,
    orderId: "#NZ1566",
    date: "04 Apr, 2020",
    billingName: "Walter Brown",
    total: "$172",
    badge: "Paid",
  },
  {
    id: 4,
    orderId: "#NZ1565",
    date: "04 Apr, 2020",
    billingName: "Paul Jones",
    total: "$183",
    badge: "Paid",
  },
  {
    id: 3,
    orderId: "#NZ1564",
    date: "04 Apr, 2020",
    billingName: "Donald Bailey",
    total: "$146",
    badge: "Paid",
  },
  {
    id: 2,
    orderId: "#NZ1563",
    date: "04 Apr, 2020",
    billingName: "Jimmy Barker",
    total: "$165",
    badge: "unpaid",
  },
  {
    id: 1,
    orderId: "#NZ1562",
    date: "04 Apr, 2020",
    billingName: "Walter Brown",
    total: "$172",
    badge: "Paid",
  },
];

export { latestTransction };
